import React, { Component } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import Offsidebar from './Offsidebar';
import Footer from './Footer';

class Base extends Component {
  constructor(props) {
    super(props);
    this.state = {
      key: 0,
      noFooter: this.props.SideBarConfig.module,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ noFooter: nextProps.SideBarConfig.module });
  }
  render() {
    let { noFooter } = this.state;
    return (
      <div className="wrapper">
        <Header
          changeProps={() => {
            this.setState({ key: Math.random() });
          }}
        />
        <Sidebar   style={{ fontSize: "13px" }} _userconfig={{ ...this.props }} />
        <Offsidebar />
        <section className={`${noFooter === "epointAnalytics" ? "seccionNOne" : "section-container"}`} key={this.state.key}>
          {this.props.children}
        </section>

        <Footer _userconfig={{ ...this.props }} />
      </div>
    );
  }
}

export default Base;
